import { Injectable } from '@angular/core';
import { PlatformApiWpService } from './platform-apiwp.service';
import { BehaviorSubject, Observable, catchError, shareReplay, take } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ChartConfigService {
  chartOverviewPromise: Promise<any> | null = null;
  chartOverviewData!: any;
  chartDataPromise!: Promise<any> | null;
  chartDataData!: any;

  constructor(
    private platformApiWpService: PlatformApiWpService
  ) { 
  }

  private _cachedData: Array<any> = [];

  private chartOverview$:BehaviorSubject<any> = new BehaviorSubject<any>([]); 

  set cachedData(data: any) {
    data.forEach((element: any) => {
      if (!this._cachedData.includes(element)) {
        this._cachedData.push(element);
      }
    })
    // if(!this._cachedData.includes(data)){
    //   this._cachedData.push(data); 
    // }
  }

  get cachedData() {
    return this._cachedData;
  }

  getCachedChartDataById(graphicInfoId: string) {
    return this._cachedData.find((element: any) => {
      return element.graphicInfo.id === graphicInfoId
    })
  }

  makeChartOverviewApiCall(data: any): Promise<any> {
    if (this.chartOverviewData) {
      return Promise.resolve(this.chartOverviewData);
    }
    this.chartOverviewPromise = new Promise((resolve, reject) => {
      if (this.chartOverviewPromise) {
        resolve(this.chartOverviewPromise);
        return
     }
      this.platformApiWpService.postRequest('/msc/v1/markerChart', data).then((res) => {
        res.pipe(
          catchError((err: any) => {
            reject(err);
            this.chartOverviewData = null
            console.log(err);
            return err;
          }),
          take(1)
        )
          .subscribe((data: any) => {
            this.chartOverviewData = data;
          resolve(data);
        });
     });
    })
    return this.chartOverviewPromise
  }

  /**
   * makeChartDataApiCall function makes a call to the chart data API endpoint.
   *
   * @param {any} data - the data to be sent in the API call
   * @return {any} the response from the API call
   */
  makeChartDataApiCall(data: any): Promise<any> {
    if(this.chartDataData) {
      return Promise.resolve(this.chartDataData);
    }
    this.chartDataPromise = new Promise((resolve, reject) => {
      if (this.chartDataPromise) {
        resolve(this.chartDataPromise);
        return
      }
      this.platformApiWpService.postRequest('/msc/v1/markerChart', data).then((res) => {
        res.pipe(
          catchError((err: any) => {
            reject(err);
            this.chartDataPromise = null
            console.log(err);
            return err;
          }),
          take(1)
        )
          .subscribe((data: any) => {
            this.chartDataData = data;
            resolve(data);
          });
      })
    })
    return this.chartDataPromise;
    // return this.platformApiWpService.postRequest('/msc/v1/markerChart', data)
  }

  /**
   * Retrieve the fatturato utile mercato for the given ATECO code.
   * ATTENZIONE: il codice ateco deve essere nel formato 62.01
   *
   * @param {string} ateco - The ATECO code for which to retrieve the data
   * @return {object} The retrieved data
   */
  retrieveFatturatoUtileMercato(ateco: string) {
    let d = new Date();
    d.setHours(0, 0, 0, 0);

    const data =
    {
      "graphConfigs": [{
        "id": "istatDataAvg",
        "title": "istatDataAvg",
        "startDate": d,
        "endDate": d,
        "dateFieldName": null,
        "x": 0,
        "y": 0,
        "rows": 4,
        "cols": 12,
        "tempNumericUnit": null,
        "numericUnit": null,
        "limitPieResults": true,
        "tableHideRawColumn": false,
        "tableDisableAddPlotrows": false,
        "displaylogo": false,
        "autosize": false,
        "type": "TABLE",
        "dataMartSource": null,
        "yaxis": [{
          "sortByField": false,
          "id": ateco,
          "idFieldName": "idAteco",
          "table": "istat_year_detail",
          "xaxis": null,
          "value": "year",
          "label": "Dati medi istat",
          "color": null,
          "dataFilter": null,
          "dataAggregate": null,
          "dataMartSource": "Istat",
          "idAtecoOccurrences": 5
        }], "mode": "number", "height": "300", "xaxesType": "category", "graphConfigId": "-istatDataAvg", "version": "0.2"
      }]
    };
    return data;
  }

  getYesterday(): Date {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    today.setDate(today.getDate() - 1);
    return today;
  }

  getThreeMonthsAgo(): Date {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    today.setMonth(today.getMonth() - 3);
    today.setDate(today.getDate() - 1);
    return today;
  }

  retrieveDeltaEbitda(ateco: string) {
    let startDate = this.getThreeMonthsAgo();
    let endDate = this.getYesterday();
    const data =
    {
      "graphConfigs": [
        {
          "id": "UUID-DSHB-d9646f1f-37e6-45fc-87ec-150ed5ed17d6",
          "title": "Delta % Fatturato Medio di Settore",
          "startDate": startDate.toISOString(),
          "endDate": endDate.toISOString(),
          "dateFieldName": null,
          "x": 0,
          "y": 2,
          "rows": 2,
          "cols": 12,
          "tempNumericUnit": null,
          "numericUnit": null,
          "limitPieResults": true,
          "tableHideRawColumn": false,
          "tableDisableAddPlotrows": false,
          "displaylogo": false,
          "autosize": false,
          "type": "INDICATOR",
          "dataMartSource": null,
          "helpKey": "istat_denominatore_medio_fatturato",
          "yaxis": [
            {
              "sortByField": false,
              "id": ateco,
              "idFieldName": "idAteco",
              "table": "istat_denominatore_medio",
              "xaxis": null,
              "value": "fatturatoMedio",
              "label": "Fatturato Medio Settore Ateco",
              "color": null,
              "dataFilter": null,
              "dataAggregate": null,
              "onClick": null,
              "dataMartSource": "Istat",
              "dateFieldName": null,
              "numericUnit": "EUR",
              "idAtecoOccurrences": 4
            }
          ],
          "mode": "number",
          "version": "0.2",
          "multipleDatasourceMetricsVisualization": null,
          "multipleDatasourceMetrics": null,
          "orientation": null,
          "showTrendLineBarChart": null,
          "graphConfigId": "27d075f4-463c-487d-b4d0-91721cfba974",
          "possibleMetrics": null
        },


        {
          "id": "UUID-DSHB-3229fd99-e663-4ab8-9418-a96dcfba6b18",
          "title": "Delta % EBITDA Medio di Settore",
          "startDate": startDate.toISOString(),
          "endDate": endDate.toISOString(),
          "dateFieldName": null,
          "x": 0,
          "y": 6,
          "rows": 2,
          "cols": 12,
          "tempNumericUnit": null,
          "numericUnit": null,
          "limitPieResults": true,
          "tableHideRawColumn": false,
          "tableDisableAddPlotrows": false,
          "displaylogo": false,
          "autosize": false,
          "type": "INDICATOR",
          "dataMartSource": null,
          "helpKey": "istat_denominatore_medio_ebitda",
          "yaxis": [

            {
              "sortByField": false,
              "id": ateco,
              "idFieldName": "idAteco",
              "table": "istat_denominatore_medio",
              "xaxis": null,
              "value": "molMedio",
              "label": "EBITDA Medio Settore Ateco",
              "color": null,
              "dataFilter": null,
              "dataAggregate": null,
              "onClick": null,
              "dataMartSource": "Istat",
              "dateFieldName": null,
              "numericUnit": "EUR",
              "idAtecoOccurrences": 4
            }
          ],
          "mode": "number",
          "version": "0.2",
          "multipleDatasourceMetricsVisualization": null,
          "multipleDatasourceMetrics": null,
          "orientation": null,
          "showTrendLineBarChart": null,
          "graphConfigId": "a2c2aba7-6160-475a-b678-58e217bb2fee",
          "possibleMetrics": null
        },


        // {
        //     "id": "UUID-DSHB-ef4f37dd-f213-4205-b445-1593d814085f",
        //     "title": "Delta % Acquisto Beni e Servizi",
        //     "startDate": startDate.toISOString(),
        //     "endDate": endDate.toISOString(),
        //     "dateFieldName": null,
        //     "x": 0,
        //     "y": 8,
        //     "rows": 2,
        //     "cols": 12,
        //     "tempNumericUnit": null,
        //     "numericUnit": null,
        //     "limitPieResults": true,
        //     "tableHideRawColumn": false,
        //     "tableDisableAddPlotrows": false,
        //     "displaylogo": false,
        //     "autosize": false,
        //     "type": "INDICATOR",
        //     "dataMartSource": null,
        //     "helpKey": "istat_denominatore_acquisti_beni_servizi_medio",
        //     "yaxis": [
        //         {
        //             "sortByField": false,
        //             "id": ateco,
        //             "idFieldName": "idAteco",
        //             "table": "istat_denominatore_acquisti_beni_servizi_medio",
        //             "xaxis": null,
        //             "value": "value",
        //             "label": "Acquisti Beni e Servizi Medio Settore Ateco",
        //             "color": null,
        //             "dataFilter": null,
        //             "dataAggregate": null,
        //             "onClick": null,
        //             "dataMartSource": "Istat",
        //             "dateFieldName": null,
        //             "numericUnit": "EUR",
        //             "idAtecoOccurrences": 4
        //         }
        //     ],
        //     "mode": "number",
        //     "version": "0.2",
        //     "multipleDatasourceMetricsVisualization": null,
        //     "multipleDatasourceMetrics": null,
        //     "orientation": null,
        //     "showTrendLineBarChart": null,
        //     "graphConfigId": "bbcfb0e9-78a5-4ea8-a31b-4aac0f15fdd3",
        //     "possibleMetrics": null
        // }
      ]
    };
    return data;
  }

  /**
     * 
     * @param ateco: ATTENZIONE il formato deve essere del tipo 6201
     * @returns 
     */
  retrieveFatturatoEbitdaAcquisti(ateco: string) {
    let startDate = this.getThreeMonthsAgo();
    let endDate = this.getYesterday();
    const data =
    {
      "graphConfigs": [
        // {
        //     "id": "UUID-DSHB-5caff251-4111-4157-906c-a23281c909fe",
        //     "title": "Fatturato, EBITDA e Acquisti - Last 3 Years (migliaia €)",
        //     "startDate": startDate.toISOString(),
        //     "endDate": endDate.toISOString(),
        //     "dateFieldName": null,
        //     "x": 0,
        //     "y": 10,
        //     "rows": 4,
        //     "cols": 12,
        //     "tempNumericUnit": null,
        //     "numericUnit": null,
        //     "limitPieResults": true,
        //     "tableHideRawColumn": false,
        //     "tableDisableAddPlotrows": false,
        //     "displaylogo": false,
        //     "autosize": false,
        //     "type": "BAR",
        //     "dataMartSource": null,
        //     "helpKey": "istat_fatturato_mol_acquisti_last3years",
        //     "yaxis": [
        //         {
        //             "sortByField": false,
        //             "id": ateco,
        //             "idFieldName": "idAteco",
        //             "table": "istat_fatturato_mol_acquisti_last3years",
        //             "xaxis": null,
        //             "value": "fatturato",
        //             "label": "Fatturato",
        //             "color": null,
        //             "dataFilter": null,
        //             "dataAggregate": {
        //                 "aggregationField": "fatturato",
        //                 "aggregationFunctionString": "MAX",
        //                 "groupByField": "anno"
        //             },
        //             "onClick": null,
        //             "dataMartSource": "Istat",
        //             "dateFieldName": null,
        //             "numericUnit": "EUR",
        //             "idAtecoOccurrences": 4
        //         },
        //         {
        //             "sortByField": false,
        //             "id": ateco,
        //             "idFieldName": "idAteco",
        //             "table": "istat_fatturato_mol_acquisti_last3years",
        //             "xaxis": null,
        //             "value": "mol",
        //             "label": "EBITDA",
        //             "color": null,
        //             "dataFilter": null,
        //             "dataAggregate": {
        //                 "aggregationField": "mol",
        //                 "aggregationFunctionString": "MAX",
        //                 "groupByField": "anno"
        //             },
        //             "onClick": null,
        //             "dataMartSource": "Istat",
        //             "dateFieldName": null,
        //             "numericUnit": "EUR",
        //             "idAtecoOccurrences": 4
        //         },
        //         {
        //             "sortByField": false,
        //             "id": ateco,
        //             "idFieldName": "idAteco",
        //             "table": "istat_fatturato_mol_acquisti_last3years",
        //             "xaxis": null,
        //             "value": "acquistoDiBeniEServizi",
        //             "label": "Acquisto Beni e Servizi",
        //             "color": null,
        //             "dataFilter": null,
        //             "dataAggregate": {
        //                 "aggregationField": "acquistoDiBeniEServizi",
        //                 "aggregationFunctionString": "MAX",
        //                 "groupByField": "anno"
        //             },
        //             "onClick": null,
        //             "dataMartSource": "Istat",
        //             "dateFieldName": null,
        //             "numericUnit": "EUR",
        //             "idAtecoOccurrences": 4
        //         }
        //     ],
        //     "mode": "number",
        //     "version": "0.2",
        //     "orientation": "v",
        //     "showTrendLineBarChart": null,
        //     "graphConfigId": "9b30a428-ef21-4de3-afdb-d65c049cf1fd",
        //     "possibleMetrics": null,
        //     "multipleDatasourceMetrics": null,
        //     "multipleDatasourceMetricsVisualization": null
        // },
        {
          "id": "UUID-DSHB-08826186-267b-4d15-8d00-0e3fe92cedf5",
          "title": "Quota di Mercato del Fatturato",
          "startDate": startDate.toISOString(),
          "endDate": endDate.toISOString(),
          "dateFieldName": null,
          "x": 0,
          "y": 0,
          "rows": 2,
          "cols": 12,
          "tempNumericUnit": null,
          "numericUnit": null,
          "limitPieResults": true,
          "tableHideRawColumn": false,
          "tableDisableAddPlotrows": false,
          "displaylogo": false,
          "autosize": false,
          "type": "INDICATOR",
          "dataMartSource": null,
          "helpKey": "istat_denominatore_fatturato",
          "yaxis": [
            {
              "sortByField": false,
              "id": ateco,
              "idFieldName": "idAteco",
              "table": "istat_denominatore_fatturato",
              "xaxis": null,
              "value": "value",
              "label": "Fatturato Settore Ateco",
              "color": null,
              "dataFilter": null,
              "dataAggregate": null,
              "onClick": null,
              "dataMartSource": "Istat",
              "dateFieldName": null,
              "numericUnit": "EUR",
              "idAtecoOccurrences": 4
            }
          ],
          "mode": "number",
          "version": "0.2",
          "multipleDatasourceMetricsVisualization": null,
          "multipleDatasourceMetrics": null,
          "orientation": null,
          "showTrendLineBarChart": null,
          "graphConfigId": "0b6f4640-bd85-41ef-94aa-870a8bb2d028",
          "possibleMetrics": null
        },
        {
          "id": "UUID-DSHB-ef77dcdc-f74b-4687-88cb-afff621b7f7f",
          "title": "Quota di Mercato EBITDA",
          "startDate": startDate.toISOString(),
          "endDate": endDate.toISOString(),
          "dateFieldName": null,
          "x": 0,
          "y": 4,
          "rows": 2,
          "cols": 12,
          "tempNumericUnit": null,
          "numericUnit": null,
          "limitPieResults": true,
          "tableHideRawColumn": false,
          "tableDisableAddPlotrows": false,
          "displaylogo": false,
          "autosize": false,
          "type": "INDICATOR",
          "dataMartSource": null,
          "helpKey": "istat_denominatore_mol",
          "yaxis": [

            {
              "sortByField": false,
              "id": ateco,
              "idFieldName": "idAteco",
              "table": "istat_denominatore_mol",
              "xaxis": null,
              "value": "value",
              "label": "EBITDA Settore Ateco",
              "color": null,
              "dataFilter": null,
              "dataAggregate": null,
              "onClick": null,
              "dataMartSource": "Istat",
              "dateFieldName": null,
              "numericUnit": "EUR",
              "idAtecoOccurrences": 4
            }
          ],
          "mode": "number",
          "version": "0.2",
          "multipleDatasourceMetricsVisualization": null,
          "multipleDatasourceMetrics": null,
          "orientation": null,
          "showTrendLineBarChart": null,
          "graphConfigId": "b3606c14-ae28-4253-b404-2a12228863f3",
          "possibleMetrics": null
        },
        {
          "id": "UUID-DSHB-d9646f1f-37e6-45fc-87ec-150ed5ed17d6",
          "title": "Delta % Fatturato Medio di Settore",
          "startDate": startDate.toISOString(),
          "endDate": endDate.toISOString(),
          "dateFieldName": null,
          "x": 0,
          "y": 2,
          "rows": 2,
          "cols": 12,
          "tempNumericUnit": null,
          "numericUnit": null,
          "limitPieResults": true,
          "tableHideRawColumn": false,
          "tableDisableAddPlotrows": false,
          "displaylogo": false,
          "autosize": false,
          "type": "INDICATOR",
          "dataMartSource": null,
          "helpKey": "istat_denominatore_medio_fatturato",
          "yaxis": [
            {
              "sortByField": false,
              "id": ateco,
              "idFieldName": "idAteco",
              "table": "istat_denominatore_medio",
              "xaxis": null,
              "value": "fatturatoMedio",
              "label": "Fatturato Medio Settore Ateco",
              "color": null,
              "dataFilter": null,
              "dataAggregate": null,
              "onClick": null,
              "dataMartSource": "Istat",
              "dateFieldName": null,
              "numericUnit": "EUR",
              "idAtecoOccurrences": 4
            }
          ],
          "mode": "number",
          "version": "0.2",
          "multipleDatasourceMetricsVisualization": null,
          "multipleDatasourceMetrics": null,
          "orientation": null,
          "showTrendLineBarChart": null,
          "graphConfigId": "27d075f4-463c-487d-b4d0-91721cfba974",
          "possibleMetrics": null
        },


        // {
        //     "id": "UUID-DSHB-3229fd99-e663-4ab8-9418-a96dcfba6b18",
        //     "title": "Delta % EBITDA Medio di Settore",
        //     "startDate": startDate.toISOString(),
        //     "endDate": endDate.toISOString(),
        //     "dateFieldName": null,
        //     "x": 0,
        //     "y": 6,
        //     "rows": 2,
        //     "cols": 12,
        //     "tempNumericUnit": null,
        //     "numericUnit": null,
        //     "limitPieResults": true,
        //     "tableHideRawColumn": false,
        //     "tableDisableAddPlotrows": false,
        //     "displaylogo": false,
        //     "autosize": false,
        //     "type": "INDICATOR",
        //     "dataMartSource": null,
        //     "helpKey": "istat_denominatore_medio_ebitda",
        //     "yaxis": [

        //         {
        //             "sortByField": false,
        //             "id": ateco,
        //             "idFieldName": "idAteco",
        //             "table": "istat_denominatore_medio",
        //             "xaxis": null,
        //             "value": "molMedio",
        //             "label": "EBITDA Medio Settore Ateco",
        //             "color": null,
        //             "dataFilter": null,
        //             "dataAggregate": null,
        //             "onClick": null,
        //             "dataMartSource": "Istat",
        //             "dateFieldName": null,
        //             "numericUnit": "EUR",
        //             "idAtecoOccurrences": 4
        //         }
        //     ],
        //     "mode": "number",
        //     "version": "0.2",
        //     "multipleDatasourceMetricsVisualization": null,
        //     "multipleDatasourceMetrics": null,
        //     "orientation": null,
        //     "showTrendLineBarChart": null,
        //     "graphConfigId": "a2c2aba7-6160-475a-b678-58e217bb2fee",
        //     "possibleMetrics": null
        // },
        // {
        //     "id": "UUID-DSHB-ef4f37dd-f213-4205-b445-1593d814085f",
        //     "title": "Delta % Acquisto Beni e Servizi",
        //     "startDate": startDate.toISOString(),
        //     "endDate": endDate.toISOString(),
        //     "dateFieldName": null,
        //     "x": 0,
        //     "y": 8,
        //     "rows": 2,
        //     "cols": 12,
        //     "tempNumericUnit": null,
        //     "numericUnit": null,
        //     "limitPieResults": true,
        //     "tableHideRawColumn": false,
        //     "tableDisableAddPlotrows": false,
        //     "displaylogo": false,
        //     "autosize": false,
        //     "type": "INDICATOR",
        //     "dataMartSource": null,
        //     "helpKey": "istat_denominatore_acquisti_beni_servizi_medio",
        //     "yaxis": [
        //         {
        //             "sortByField": false,
        //             "id": ateco,
        //             "idFieldName": "idAteco",
        //             "table": "istat_denominatore_acquisti_beni_servizi_medio",
        //             "xaxis": null,
        //             "value": "value",
        //             "label": "Acquisti Beni e Servizi Medio Settore Ateco",
        //             "color": null,
        //             "dataFilter": null,
        //             "dataAggregate": null,
        //             "onClick": null,
        //             "dataMartSource": "Istat",
        //             "dateFieldName": null,
        //             "numericUnit": "EUR",
        //             "idAtecoOccurrences": 4
        //         }
        //     ],
        //     "mode": "number",
        //     "version": "0.2",
        //     "multipleDatasourceMetricsVisualization": null,
        //     "multipleDatasourceMetrics": null,
        //     "orientation": null,
        //     "showTrendLineBarChart": null,
        //     "graphConfigId": "bbcfb0e9-78a5-4ea8-a31b-4aac0f15fdd3",
        //     "possibleMetrics": null
        // }
      ]
    };
    return data;
  }

  retrieveInnovationIndex(ateco: string) {
    let startDate = this.getThreeMonthsAgo();
    let endDate = this.getYesterday();
    const data = {
      "graphConfigs": [
        {
          "id": "UUID-DSHB-b5cc37fe-9d7f-4407-8be2-28393745674a",
          "title": "Index Innovation (%)",
          "startDate": startDate.toISOString(),
          "endDate": endDate.toISOString(),
          "dateFieldName": null,
          "x": 2,
          "y": 0,
          "rows": 4,
          "cols": 1,
          "tempNumericUnit": null,
          "numericUnit": null,
          "limitPieResults": true,
          "tableHideRawColumn": false,
          "tableDisableAddPlotrows": false,
          "displaylogo": false,
          "autosize": false,
          "type": "INDICATOR",
          "dataMartSource": null,
          "helpKey": "istat_index_innovation",
          "yaxis": [
            {
              "sortByField": false,
              "id": ateco,
              "idFieldName": "idAteco",
              "table": "istat_index_innovation",
              "xaxis": null,
              "value": "value",
              "label": " ",
              "color": null,
              "dataFilter": null,
              "dataAggregate": null,
              "onClick": null,
              "dataMartSource": "Istat",
              "dateFieldName": null,
              "numericUnit": "percentage",
              "idAtecoOccurrences": 2
            }
          ],
          "mode": "number",
          "version": "0.2",
          "orientation": null,
          "showTrendLineBarChart": null,
          "graphConfigId": "e1206b86-e2e8-459c-b95d-5a5293cdf6ca"
        },
      ]
    };
    return data;
  }

  retrieveChartOverview(ateco: string) {
    let startDate = this.getThreeMonthsAgo();
    let endDate = this.getYesterday();
    const data = {
      "graphConfigs": [
        {
          "id": "UUID-DSHB-08826186-267b-4d15-8d00-0e3fe92cedf5",
          "title": "Quota di Mercato del Fatturato",
          "startDate": startDate.toISOString(),
          "endDate": endDate.toISOString(),
          "dateFieldName": null,
          "x": 0,
          "y": 0,
          "rows": 2,
          "cols": 12,
          "tempNumericUnit": null,
          "numericUnit": null,
          "limitPieResults": true,
          "tableHideRawColumn": false,
          "tableDisableAddPlotrows": false,
          "displaylogo": false,
          "autosize": false,
          "type": "INDICATOR",
          "dataMartSource": null,
          "helpKey": "istat_denominatore_fatturato",
          "yaxis": [
            {
              "sortByField": false,
              "id": ateco,
              "idFieldName": "idAteco",
              "table": "istat_denominatore_fatturato",
              "xaxis": null,
              "value": "value",
              "label": "Fatturato Settore Ateco",
              "color": null,
              "dataFilter": null,
              "dataAggregate": null,
              "onClick": null,
              "dataMartSource": "Istat",
              "dateFieldName": null,
              "numericUnit": "EUR",
              "idAtecoOccurrences": 4
            }
          ],
          "mode": "number",
          "version": "0.2",
          "multipleDatasourceMetricsVisualization": null,
          "multipleDatasourceMetrics": null,
          "orientation": null,
          "showTrendLineBarChart": null,
          "graphConfigId": "0b6f4640-bd85-41ef-94aa-870a8bb2d028",
          "possibleMetrics": null
        },
        {
          "id": "UUID-DSHB-d9646f1f-37e6-45fc-87ec-150ed5ed17d6",
          "title": "Delta % Fatturato Medio di Settore",
          "startDate": startDate.toISOString(),
          "endDate": endDate.toISOString(),
          "dateFieldName": null,
          "x": 0,
          "y": 2,
          "rows": 2,
          "cols": 12,
          "tempNumericUnit": null,
          "numericUnit": null,
          "limitPieResults": true,
          "tableHideRawColumn": false,
          "tableDisableAddPlotrows": false,
          "displaylogo": false,
          "autosize": false,
          "type": "INDICATOR",
          "dataMartSource": null,
          "helpKey": "istat_denominatore_medio_fatturato",
          "yaxis": [
            {
              "sortByField": false,
              "id": ateco,
              "idFieldName": "idAteco",
              "table": "istat_denominatore_medio",
              "xaxis": null,
              "value": "fatturatoMedio",
              "label": "Fatturato Medio Settore Ateco",
              "color": null,
              "dataFilter": null,
              "dataAggregate": null,
              "onClick": null,
              "dataMartSource": "Istat",
              "dateFieldName": null,
              "numericUnit": "EUR",
              "idAtecoOccurrences": 4
            }
          ],
          "mode": "number",
          "version": "0.2",
          "multipleDatasourceMetricsVisualization": null,
          "multipleDatasourceMetrics": null,
          "orientation": null,
          "showTrendLineBarChart": null,
          "graphConfigId": "27d075f4-463c-487d-b4d0-91721cfba974",
          "possibleMetrics": null
        },
        {
          "id": "UUID-DSHB-b5cc37fe-9d7f-4407-8be2-28393745674a",
          "title": "Index Innovation (%)",
          "startDate": startDate.toISOString(),
          "endDate": endDate.toISOString(),
          "dateFieldName": null,
          "x": 2,
          "y": 0,
          "rows": 4,
          "cols": 1,
          "tempNumericUnit": null,
          "numericUnit": null,
          "limitPieResults": true,
          "tableHideRawColumn": false,
          "tableDisableAddPlotrows": false,
          "displaylogo": false,
          "autosize": false,
          "type": "INDICATOR",
          "dataMartSource": null,
          "helpKey": "istat_index_innovation",
          "yaxis": [
            {
              "sortByField": false,
              "id": ateco,
              "idFieldName": "idAteco",
              "table": "istat_index_innovation",
              "xaxis": null,
              "value": "value",
              "label": " ",
              "color": null,
              "dataFilter": null,
              "dataAggregate": null,
              "onClick": null,
              "dataMartSource": "Istat",
              "dateFieldName": null,
              "numericUnit": "percentage",
              "idAtecoOccurrences": 2
            }
          ],
          "mode": "number",
          "version": "0.2",
          "orientation": null,
          "showTrendLineBarChart": null,
          "graphConfigId": "e1206b86-e2e8-459c-b95d-5a5293cdf6ca"
        },
       
      ]
    };
    return data;
  }
}
